export default __webpack_public_path__ + "static/media/wave-up.409df162.svg";